<template>
  <Transition>
    <div v-show="open" class="Accordion">
      <slot />
    </div>
  </Transition>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  props: {
    open: {
      type: Boolean,
      default: false,
    }
  }
})
</script>

<style scoped>
.v-enter-active {
  animation: open .2s ease;
}

@keyframes open {
  0% {
    transform: translateY(-10px);
    opacity: 0;
  }
  100% { 
    transform: translateY(0);
    opacity: 1;
  }
}
</style>